import styled from 'styled-components'
import { colors } from '../../../styles/colors'

export const Container = styled.div`
    padding: 10px 0;
    font-size: 12px;

    > * + * {
        margin-top: 10px;
    }
`

export const Title = styled.h1`
    font-size: 16px;
    font-weight: 700;
    color: ${colors.lime};
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 10px;
    }
`

export const SubTitle = styled.span`
    font-size: 12px;
    font-weight: 700;
    line-height: 14px;

    color: ${colors.lime};
`

export const Item = styled.div`
    display: flex;

    font-size: 12px;
    font-weight: 300;

    > * + * {
        margin-left: 10px;
    }
`

export const Icon = styled.img`
    display: block;
    margin: 0 auto;
`
